'use client';

import { createContext, useContext } from 'react';

/**
 * Maps a Contentful asset id → its description (falling back to title), built server-side
 * from the fetched experience's entity store and provided around the experience tree.
 *
 * The Experiences SDK only hands a Media variable's URL to a component (never the asset's
 * description), so logo items resolve their alt text from this map during render — automatic
 * (no manual binding in Studio) and available in the server-rendered HTML.
 */
export const LogoAltContext = createContext<Record<string, string>>({});

export const useLogoAlt = () => useContext(LogoAltContext);

/**
 * Contentful asset URLs look like `//images.eu.ctfassets.net/{spaceId}/{assetId}/{token}/file`.
 * The asset id is the path segment immediately after the space id.
 */
export const assetIdFromUrl = (url: string): string | undefined => {
  const match = url.match(/ctfassets\.net\/[^/]+\/([^/]+)\//);
  return match?.[1];
};
